var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.00036H18.67C19.236 0.990352 19.7859 1.1885 20.2154 1.55718C20.645 1.92586 20.9242 2.43942 21 3.00036V10.0004C20.9242 10.5613 20.645 11.0749 20.2154 11.4435C19.7859 11.8122 19.236 12.0104 18.67 12.0004H16M9.00003 14.0004V18.0004C9.00003 18.796 9.3161 19.5591 9.87871 20.1217C10.4413 20.6843 11.2044 21.0004 12 21.0004L16 12.0004V1.00036H4.72003C4.2377 0.994909 3.76965 1.16396 3.40212 1.47636C3.0346 1.78875 2.79235 2.22346 2.72003 2.70036L1.34003 11.7004C1.29652 11.987 1.31586 12.2797 1.39669 12.5581C1.47753 12.8365 1.61793 13.0941 1.80817 13.3128C1.99842 13.5316 2.23395 13.7064 2.49846 13.8251C2.76297 13.9439 3.05012 14.0036 3.34003 14.0004H9.00003Z",
    stroke: "url(#paint0_linear_1416_44731)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1416_44731",
    x1: 11.1587,
    y1: -10.2664,
    x2: -11.3285,
    y2: 9.37639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.36fc581b2d64ffc7a8718a69728d542a.svg";
export { ForwardRef as ReactComponent };